import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { rebuildTooltip, Text, Tooltip } from '@sevensenders/component-library';
import { ReactComponent as InfoIcon } from '../../../icons/info.svg';
import { useTranslation } from 'react-i18next';

export default function InfoCell({ value, row: { original: data }, column }) {
  const { t } = useTranslation();

  const tooltip = column?.tooltip || '';
  const subText = column?.subText || '';
  const { id } = data;

  useEffect(() => {
    rebuildTooltip();
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <Tooltip id={`infoTooltip-${id}`} tip="" place="right" showByDefault={false} />
      <Text inline={false}>{value}</Text>
      <Text secondary small inline={false}>
        {subText}
      </Text>
      <span data-for={`infoTooltip-${id}`} data-tip={t(tooltip)}>
        <InfoIcon width="16" height="16" />
      </span>
    </div>
  );
}

InfoCell.propTypes = {
  value: PropTypes.string,
  column: PropTypes.any,
  row: PropTypes.any,
};
